import React, { Component } from "react";
import ReactDOM from 'react-dom';
import Grid from '@material-ui/core/Grid'
import { ProgressBar, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import LockIcon from '@material-ui/icons/Lock';

import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import '../../App.css';
import './Cards.css'
import ModalBox from '../Modal'
// images
import logoimg from '../../img/busdlogo.png'
import Lock from '../../img/lockicon.png'




const Pairs = (props) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const percentage = 100;
  const percentage1 = 34;
  const percentage2 = 11;
  return (
    <Grid
      container
      direction="column"
      justify="flex-start"
      xs={12}
      className="pcc---buyCard my-3"
    >
      <button className="pcc---buyCardBoxs px-2 px-md-4 py-4" type="button" onClick={() => props.pairModel('openModel')}>

        <Grid
          container
          direction="row"
          justify="flex-start"
          xs={12}
          className="pcc---buyCard"
        >
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignContent="space-between"
            xs={12}
            sm={8}
            className="pcc---buyCard"
          >
            <div className="text-left">
              <h2 className="mb-0" style={{textAlign:'left',padding:'0px',border:'none',fontSize: '30px',display: "block"}}>
                <img src={logoimg} style={{height:"100%",width:'auto',maxHeight:30,marginRight: 5}}/><strong>BUSD</strong>
                <strong className="mx-2 d-inline-block">/</strong>
                <img src={logoimg} style={{height:"100%",width:'auto',maxHeight:30,marginRight: 5}}/><strong>BUSD</strong>
              </h2>
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justify="flex-start"
          xs={12}
          className="pcc---buyCard pl-md-4"
        >
          <Grid
            container
            direction="row"
            justify="space-between"
            alignContent="space-between"
            alignItems="center"
            xs={12}
            sm={8}
            className="pcc---buyCard pl-md-2"
          >
            <p className="mb-0">470.02 M </p>
            <p className="mb-0">3k</p>
            <p className="mb-0 text-right">
              <a href="#" className="mr-2 pcc---infoLInks">
                  Pair <OpenInNewOutlinedIcon />
              </a>
              <a href="#" className="pcc---infoLInks">
                  Reload <OpenInNewOutlinedIcon />
              </a>
            </p>
          </Grid>
          <Grid
            container
            direction="column"
            alignItems="center"
            xs={6}
            className="pcc---buyCard mt-2 pl-md-2"
          >
            <p className="mb-0 w-100 text-left">PancakeswapV2 index 6128</p>
            <p className="mb-0 w-100 text-left">Liquidity : ?</p>
          </Grid>
          <Grid
            container
            direction="column"
            alignItems="center"
            xs={6}
            className="pcc---buyCard mt-3"
          >
            <div className="text-right w-100" style={{padding:'0px',border:'none',fontSize: '18px'}} >
              <strong className="ml-1 d-inline-block">$2.4M</strong> / 82.2% <LockIcon style={{width:'25px',marginTop:'-6px',color:'#fdb134'}}/>
            </div>
            <div className="text-right w-100" style={{padding:'0px',border:'none',fontSize: '18px',color:"#9a9a9a"}} >
              <p className="mb-0">next in a year</p>
            </div>
          </Grid>          
        </Grid>
      </button> 
      <ModalBox 
        open={open}
        handleClose={handleClose}
      /> 
    </Grid>
  );
}

export default Pairs;



